import React from 'react';
import Datetime from 'react-datetime';
import map from 'lodash/map';
import {
    Button,
    Col,
    ControlLabel,
    Form,
    FormGroup,
    FormControl,
    Panel,
    Row,
    Checkbox,
} from 'react-bootstrap';
import { ABNORMALITIES, I18N } from '../../../constants';
import { searchFormHasValues } from '../../../shared/utils/search';

export default class FollowUpSearch extends React.PureComponent {
    render() {
        const {
            search,
            isFetching,
            title,
            handleChange,
            handleDateChange,
            handleSubmit,
            handleReset,
            handleCheckboxChange,
        } = this.props;

        return (
            <Panel collapsible defaultExpanded={searchFormHasValues(search)} header={'Search'}>
                <Form horizontal onSubmit={handleSubmit}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="abnormalityName">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Abn. name
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="abnormalityName"
                                        value={search.abnormalityName}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="abnormalityDate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Abn. date
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        name="abnormalityDate"
                                        value={search.abnormalityDate}
                                        onChange={handleDateChange('abnormalityDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        inputProps={{
                                            maxLength: 255,
                                            placeholder: '...',
                                        }}
                                        closeOnSelect
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="abnormalityType">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Abn. type
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="abnormalityType"
                                        value={search.abnormalityType}
                                        onChange={handleChange}
                                    >
                                        <option value="">...</option>
                                        {map(ABNORMALITIES, a => (
                                            <option key={a} value={a}>
                                                {I18N.ABNORMALITIES[a]}
                                            </option>
                                        ))}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="routeCode">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Route code
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="routeCode"
                                        value={search.routeCode}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="runDate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Run date
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        name="runDate"
                                        value={search.runDate}
                                        onChange={handleDateChange('runDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        className="date-input"
                                        inputProps={{
                                            maxLength: 255,
                                            placeholder: '...',
                                        }}
                                        closeOnSelect
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="destination">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Destination
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="destination"
                                        value={search.destination}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="location">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Location
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="location"
                                        value={search.location}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="assigneeGroup">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Assignee group
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="assigneeGroup"
                                        value={search.assigneeGroup}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="assignee">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Assignee
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="assignee"
                                        value={search.assignee}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                        {title == "TODO" && (
                            <FormGroup controlId="isOverdueRecoveryAction">
                                <Col
                                    componentClass={ControlLabel}
                                    sm={5}
                                    title="isOverdueRecoveryAction"
                                >
                                    Only Overdue Recovery
                                </Col>
                                <Col sm={6} style={{ marginTop: -7, marginBottom: 7 }}>
                                    <Checkbox
                                        name="isOverdueRecoveryAction"
                                        checked={search.isOverdueRecoveryAction}
                                        onChange={handleCheckboxChange}
                                        inline
                                    />
                                </Col>
                            </FormGroup>
                            )}
                            <FormGroup>
                                <Col sm={6} smOffset={5}>
                                    <Button
                                        type="submit"
                                        style={{ width: '100%' }}
                                        bsStyle="primary"
                                        disabled={isFetching}
                                    >
                                        {isFetching ? 'Searching...' : 'Search'}
                                    </Button>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col sm={6} smOffset={5}>
                                    <Button
                                        type="reset"
                                        style={{ width: '100%' }}
                                        disabled={isFetching}
                                        onClick={handleReset}
                                    >
                                        Reset search
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </Panel>
        );
    }
}
